function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h40v25h-40z"
}));

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "b",
  height: 25,
  maskUnits: "userSpaceOnUse",
  width: 40,
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  d: "m.3125 24.8103h39.1969v-24.4978h-39.1969z",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m40 23.667c0 .7363-.5973 1.333-1.3337 1.333h-37.33329c-.736343 0-1.33301-.5967-1.33301-1.333v-22.33397c0-.736357.596667-1.33303 1.33301-1.33303h37.33329c.7364 0 1.3337.596673 1.3337 1.33303z",
  fill: "#0078a9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.4741 11.991v-.3919l-.1875.3919h-1.6228l-.2038-.4206v.4206h-3.03344l-.35843-.8484h-.60782l-.37968.8484h-1.57282v-2.56093l1.15282-2.60876h2.20781l.31.73908v-.73344h2.69966l.5938 1.24437.5809-1.25001h8.5231s.4466-.00592.741.20095l-.0019-.20095h2.1472v.28251s.3862-.28251.9572-.28251h3.789l.3325.75001v-.75001h2.4282l.4406.75001v-.75001h2.3209v5.17469h-2.3844l-.5603-.9022v.8972h-2.964l-.4169-.9241h-.5809l-.3907.9241h-1.7937s-.6691-.0084-1.1706-.3675v.3675h-3.5713v-1.2072c0-.1753-.1344-.1631-.1344-.1631h-.1306v1.3703z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.6919 13.1113h4.6925l.6775.7666.6925-.7666h3.6078s.3388.0085.6606.18v-.18h3.2128c.4079 0 .75.2038.75.2038v-.2038h4.1297v.1882s.2941-.1882.6897-.1882h2.6903v.1882s.3388-.1882.6972-.1882h2.1125v4.8763s-.2778.314-.8522.314h-2.785v-.155s-.265.155-.669.155h-7.3978v-1.2603c0-.1237-.0538-.1465-.1644-.1465h-.1019v1.4068h-2.3119v-1.3981s-.2565.1378-.685.1378h-.8312v1.2603h-2.8497l-.6481-.7909-.6935.7909h-4.6234z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0078a9"
}, /*#__PURE__*/React.createElement("path", {
  d: "m25.4814 13.8896h2.945v.7897h-2.0434v.6885h1.9859v.6959h-1.9859v.7244h2.0434v.7703h-2.945z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.1151 15.3194c1.1065.0569 1.1993.6097 1.1993 1.1994 0 .6871-.5653 1.0565-1.1547 1.0565h-1.8921v-.7869h1.474c.25 0 .6225 0 .6225-.3521 0-.1672-.0653-.2741-.3315-.3022-.1185-.0169-.556-.0413-.6225-.0425-.9997-.0263-1.2329-.5238-1.2329-1.1294 0-.6878.4835-1.0638 1.0735-1.0638h1.8915v.7863h-1.3843c-.3147.0031-.6547-.0372-.6547.3184 0 .2253.1678.2707.3806.2913.0741 0 .5653.0256.6313.025z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.723 15.3194c1.1072.0569 1.2.6097 1.2 1.1994 0 .6871-.5646 1.0565-1.1546 1.0565h-1.8916v-.7869h1.4741c.2493 0 .6225 0 .6225-.3521 0-.1672-.066-.2741-.3322-.3022-.1185-.0169-.5566-.0413-.6219-.0425-1.0009-.0263-1.2322-.5238-1.2322-1.1294 0-.6878.4828-1.0638 1.0722-1.0638h1.8916v.7863h-1.3838c-.3153.0031-.6553-.0372-.6553.3184 0 .2253.1684.2707.3812.2913.0735 0 .5647.0256.63.025z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.7405 15.5656h-1.1219v-.8806h1.1257c.3771 0 .4962.2415.4962.4215 0 .246-.1312.4591-.5.4591zm-2.0306 1.6484-1.2941-1.5312 1.2941-1.4332zm-3.4431-.4259h-2.0769v-.7244h1.9865v-.6959h-1.9865v-.6885l2.1906.005.8769.9985zm5.7771-2.8906h-3.1612l-1.0319 1.1384-.9987-1.1463h-3.5503v3.6688h3.435l1.0815-1.2122 1.056 1.2206h1.7284v-1.2456h1.2116c.4668 0 1.319-.0159 1.319-1.3019 0-.9175-.6469-1.1218-1.0894-1.1218z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.6171 15.5166h-1.1219v-.8313h1.1256c.3766 0 .4956.2416.4956.4216 0 .2456-.1306.4097-.4993.4097zm.7775.3796c.4918-.2453.6225-.5731.6225-1.0156 0-.7856-.6382-.9822-1.081-.9822h-2.3419v3.6688h.901v-1.2944h1.1794c.3112 0 .4337.3113.4418.6225l.0238.6719h.8769l-.0329-.7538c0-.59-.1628-.8684-.5896-.9172z"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.9551 11.2298h.9009v-3.67316h-.9009z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.5815 7.56055h2.9438v.78968h-2.0428v.68844h1.9853v.69594h-1.9853v.72439h2.0428v.7703h-2.9438z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.0824 9.17867h-1.1219v-.83125h1.1263c.3759 0 .4956.24156.4956.42156 0 .24625-.1313.40969-.5.40969zm.7781.37969c.4919-.24469.6225-.57313.6225-1.01563 0-.78625-.6387-.98218-1.0809-.98218h-2.3425v3.66875h.9009v-1.29375h1.1794c.3112 0 .4344.31065.4425.62185l.0244.6719h.8762l-.0322-.7538c0-.58933-.164-.86777-.5903-.91714z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.15715 9.61867.53719-1.2825.55968 1.2825zm6.34655-2.05812-1.1056 2.46095-1.1016-2.46095h-1.41216v3.53345l-1.5725-3.53345h-1.19188l-1.60531 3.66875h.95031l.35156-.8191h1.79813l.35656.8191h1.81313v-2.72344l1.20436 2.72344h.8191l1.2322-2.67813v2.67813h.9009v-3.66875z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.6182 9.62047.5366-1.2825.565 1.2825zm5.5329-2.06188v2.54031l-1.5191-2.54031h-1.3312v3.44561l-1.5344-3.44373h-1.1922l-1.2406 2.84183s-.5244 0-.5775-.0128c-.2166-.0447-.556-.1978-.5604-.84466v-.26625c0-.86.4669-.92281 1.0657-.92281h.5559v-.79719h-1.1759c-.4097 0-1.3007.3125-1.3307 1.81969-.0206 1.01562.4219 1.85282 1.421 1.85282h1.1878l.3516-.8191h1.7975l.3562.8191h1.7775v-2.68657l1.621 2.68657h1.2287v-3.67251z"
}))));

function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 25",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.722a82c2.svg";
export { ForwardRef as ReactComponent };